import * as React from 'react';

import './check-radio.css';
import { CheckRadioProps } from '../../types';

class CheckRadio extends React.Component<CheckRadioProps, any> {
  constructor(props: CheckRadioProps) {
    super(props);
  }

  public render() {
    const labelClassName = this.props.labelClassName || '';
    const layoutClassName = this.props.layoutClassName || '';
    const inputClassName = this.props.inputClassName || '';

    const options = this.props.options.map((option, index) =>
      <span key={option}>
        <input
            checked={option === this.props.value}
            className={`is-checkradio generic-checkradio-input ${inputClassName}`.trim()}
            id={`${this.props.name}-${index}`}
            onChange={this.props.onChange}
            name={`${this.props.name}`}
            type={this.props.type}
            value={option}
        />
        <label htmlFor={`${this.props.name}-${index}`}>{option}</label>
      </span>
    );

    return (
      <div id={this.props.id} className={`field generic-checkradio-wrapper ${layoutClassName}`.trim()}>
        {this.props.label && <label className={`field-label generic-checkradio-label ${labelClassName}`.trim()}>{this.props.label}</label>}
        <div className="field-body control generic-checkradio-control">
          {...options}
        </div>
      </div>
    )
  }
}

export default CheckRadio;



// WEBPACK FOOTER //
// ./src/common/forms/check-radio.tsx